import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import { jwtDecode } from "jwt-decode";
import utilsService from '@/api/utilsService';
Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes,
  linkActiveClass: 'active',
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  }
});


router.beforeEach(async (to, from, next) => {
  utilsService.syncSessionFromShared();
  const token = localStorage.getItem('user-session');
  const isAuthenticated = !!token;
  const hasUnsavedChanges = localStorage.getItem('hasUnsavedChanges') === 'true';

  if (hasUnsavedChanges) {
    const result = await Swal.fire({
      title: 'Tienes cambios sin guardar',
      text: '¿Estás seguro de abandonar esta página?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Guardar',
      cancelButtonText: 'Salir sin guardar',
    });

    if (result.isConfirmed) {
      if (Vue.prototype.$globalMethods.submitForm) {
        await Vue.prototype.$globalMethods.submitForm(true);
        Swal.fire({
          title: "Guardado correctamente",
          icon: "success",
          showConfirmButton: false,
          timer: 2000,
          background: '#f8f9fa',
          customClass: {
            title: 'swal-title',
            icon: 'swal-icon',
          },
        });
        next(); 
      } else {
        next(false); 
      }
    } else {
      next(false); 
    }
    
    localStorage.setItem('hasUnsavedChanges', 'false');
    next(false);
  }

  try {

    if (to.name !== 'login' && !isAuthenticated) {
      next({ name: 'login' });
    }
    else if ((to.name !== 'login' && isAuthenticated)) {
      
      const decoded = jwtDecode(token);

      const currentTime = Date.now() / 1000;
      if (decoded.exp < currentTime) {
        localStorage.removeItem('user-session');
        next({ name: 'login' });
        return;
      }

      // Sincronizar rol local desde el API (chatarra trata todos como admin)
      if (!localStorage.getItem('__me_loaded__')) {
        await utilsService.getMe();
        localStorage.setItem('__me_loaded__', '1');
      }
      const userRole = localStorage.getItem('user-role') || decoded.rol || '';

      if (to.meta.requiresAdmin && userRole !== 'admin') {
        next({ name: 'error' });
        return;
      } else {
        next();
        return;
      }
    } 
    next();
  } catch (error) {
    next({ name: 'login' });
    return;
  }
});

export default router;
